import { times } from 'lodash';
import { CalendarService } from '../../utils/services';

type CalendarServiceGetter<D, M, Y> = () => CalendarService<D, M, Y>;

interface GenerateMonthProps<D, M, Y> {
    month: M;
    numberOfMonths: number;
    getCalendarService: CalendarServiceGetter<D, M, Y>;
}

export const generateMonths = <D, M, Y>({ month, numberOfMonths, getCalendarService }: GenerateMonthProps<D, M, Y>) =>
    times(numberOfMonths, (i) => getCalendarService().addMonths(month, i));

export const getMonthUniquePosition = <D, M, Y>(
    month: M,
    months: M[],
    getCalendarService: CalendarServiceGetter<D, M, Y>
) => months.findIndex((item) => getCalendarService().isMonthEqual(item, month));

export const getMonthSelectedPosition = <D, M, Y>(
    monthSelectedIndex: number,
    months: M[],
    getCalendarService: CalendarServiceGetter<D, M, Y>
) => months.findIndex((item) => getCalendarService().getMonthIndex(item) === monthSelectedIndex);
